import DateComponents from './Date.vue';

const dates = {
    install:function(Vue) {
        Vue.component('dates', DateComponents)
    }
}

export default dates;